<template>
  <div class="intro">
    <div class="video">
      <vimeo-player
        ref="player"
        :video-id="675951695"
        @ended="videoEnded"
        :options="options"
      />
    </div>
    <img class="logo" src="@/assets/images/header/primary-white.svg" />
    <img
      class="unmute"
      :class="{ visible: muteVisible }"
      @click="unmute()"
      src="@/assets/images/sound-icon.svg"
    />
    <div class="video_text">
      <button
        type="button"
        @click.prevent="skipVideo"
        @click="store.dispatch('purl/purlTracking', 'Skipped Video')"
      >
        Skip Video
      </button>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, computed } from "vue";
import { useStore } from "vuex";

export default {
  name: "IntroVideo",
  props: ["skipVideo", "videoEnded"],
  setup() {
    const store = useStore();

    // State
    const state = reactive({
      purl: computed(() => store.getters["purl/getAccount"]),
    });

    return { ...toRefs(state), store };
  },
  data() {
    return {
      options: {
        responsive: true,
        background: true,
      },
      muteVisible: true,
    };
  },
  mounted() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    window.addEventListener("resize", () => {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    });
  },
  methods: {
    unmute() {
      this.$refs.player.unmute();
      this.muteVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.intro {
  // height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  width: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  z-index: 40;
  background: #000000;
  .video {
    width: 100% !important;
    height: 100vh !important;
    min-width: 1400px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 0;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    & > div {
      transform: scale(1.5);
      @include media-breakpoint-down(sm) {
        transform: scale(1.2);
      }
    }
    &::after {
      content: "";
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      background: #0000006b;
    }
    &_text {
      position: absolute;
      z-index: 1;
      right: 44px;
      bottom: 38px;
      // @include media-breakpoint-down(sm) {
      //   bottom: 200px;
      // }
      display: flex;
      button {
        display: flex;
        justify-content: center;
        align-items: center;
        background: #de1e35;
        border: none;
        outline: none;
        height: 38px;
        width: 128px;
        font-family: Abolition;
        font-weight: normal;
        font-size: 20px;
        line-height: 24px;
        letter-spacing: normal;
        color: #ffffff;
      }
    }
  }
  .logo {
    position: absolute;
    top: 28px;
    left: 28px;
    height: 68px;
    object-fit: contain;
    z-index: 1;
  }
  .unmute {
    display: none;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 76px;
    object-fit: contain;
    cursor: pointer;
    &.visible {
      display: block;
    }
  }
}
</style>